module.exports = __webpack_public_path__ + "img/05_cg.403a3aac.png";